import { CommerceError } from '@commerce/utils/errors'
import { Maybe } from '../schema'

import { normalizeActualCart } from './normalize'
import throwUserErrors from './throw-user-errors'

export type CartQuery = {
  cart: any
  userErrors?: Array<any>
}

export type CartPayload = CartQuery

const cartToCart = (cartPayload?: Maybe<CartPayload>): any => {
  const cart = cartPayload?.cart
  throwUserErrors(cartPayload?.userErrors)

  if (!cart) {
    throw new CommerceError({
      message: 'Missing cart object from response',
    })
  }

  return normalizeActualCart(cart)
}

export default cartToCart
